import React, { useState } from "react"
import { Link, NavLink } from "react-router-dom"

const links = [
  ["Properties", "/properties"],
  ["List your property", "/list-your-property"],
  ["About", "/about"],
  ["Contact", "/contactus"]
]

export default function Nav({ overlay = false }) {
  const [open, setOpen] = useState(false)
  const navClass = ({ isActive }) => `${overlay ? "text-white/90 hover:text-white" : "broker-nav-link"} text-sm font-semibold ${isActive && !overlay ? "broker-nav-active" : ""}`
  return (
    <header className={`${overlay ? "absolute left-0 right-0 top-0 border-white/15 bg-gradient-to-b from-slate-950/75 to-transparent text-white" : "sticky top-0 border-slate-200 bg-white/95"} z-40 border-b backdrop-blur-sm`}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" className="flex items-center gap-3" aria-label="Saamling home">
          <img src="/brand/saamling-mark-dark.jpg" alt="" className={`h-11 w-11 rounded-[13px] object-cover ${overlay ? "ring-1 ring-white/30 shadow-lg shadow-slate-950/20" : "shadow-sm"}`} />
          <span><span className={`block text-lg font-bold tracking-tight ${overlay ? "text-white" : "text-[#0B2D5B]"}`}>Saamling</span><span className={`block text-[11px] font-semibold uppercase tracking-[0.22em] ${overlay ? "text-[#F3E7D5]" : "text-[#D4A017]"}`}>Real Estate · Bhutan</span></span>
        </Link>
        <nav className="hidden items-center gap-7 md:flex">
          {links.map(([label, path]) => <NavLink key={path} to={path} className={navClass}>{label}</NavLink>)}
          <Link to="/list-your-property" className={`rounded-xl px-5 py-2.5 text-sm font-semibold transition ${overlay ? "bg-[#D4A017] text-[#0B2D5B] hover:bg-[#e2b642]" : "bg-[#0B2D5B] text-white hover:bg-[#174b82]"}`}>Post property <span className="ml-1 rounded bg-white/90 px-1.5 py-0.5 text-[10px] text-[#0B2D5B]">FREE</span></Link>
        </nav>
        <button className={`rounded-xl border p-2 md:hidden ${overlay ? "border-white/30 bg-white/10" : "border-slate-200"}`} onClick={() => setOpen(!open)} aria-label="Toggle navigation">
          <span className={`block h-0.5 w-6 ${overlay ? "bg-white" : "bg-slate-800"}`}/><span className={`my-1.5 block h-0.5 w-6 ${overlay ? "bg-white" : "bg-slate-800"}`}/><span className={`block h-0.5 w-6 ${overlay ? "bg-white" : "bg-slate-800"}`}/>
        </button>
      </div>
      {open && <nav className="space-y-1 border-t border-slate-100 bg-white p-4 md:hidden">
        {links.map(([label, path]) => <NavLink key={path} to={path} onClick={() => setOpen(false)} className="block rounded-xl px-4 py-3 font-medium text-slate-700 hover:bg-emerald-50">{label}</NavLink>)}
      </nav>}
    </header>
  )
}
